var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MultiChartCard',{staticClass:"mb-4",attrs:{"data":_vm.chart,"height":300,"loading":_vm.loading,"title":_vm.$t('dashboard.overview'),"range":_vm.timeRange.groupBy},on:{"currentChart":_vm.setCurrentChart}})
}
var staticRenderFns = []

export { render, staticRenderFns }